import { createAction } from "@reduxjs/toolkit";



export const initSystem = createAction<any>("system/init");